export default __webpack_public_path__ + "static/media/15.7003e87a.png";